module.exports = __webpack_public_path__ + "assets/img/AquavistaGlass-Website.3b217ea3.jpg";